
export const categorias = {
  ANALISIS: 1,
  DILUCION: 2,
  ENVASADO: 3,
  ANALISIS_DILUCION: 4
}